import React from 'react'

export const Sso = () => {
  return (
    <div></div>
  )
}
